import { projectsProjectDetailHostCapability, projectsProjectDetailHostSlots, } from '@crest/module-projects/contracts/detail-host';
import { defineProjectsProjectDetailLauncher } from '@crest/module-projects/contracts/detail-launcher';
import { scanningMediaModuleManifest } from '../scanning-media.module.js';
import { scanningMediaSettingRegistrations } from '../settings/scanning-media-setting-definitions.js';
export const scanningMediaWebModuleContribution = {
    moduleId: 'scanning-media',
    manifest: scanningMediaModuleManifest,
    settingRegistrations: scanningMediaSettingRegistrations,
    settingEditors: [],
    hostContracts: [],
    hostContributions: [{
            id: 'scanning-media.web.projects.scan-readback',
            moduleId: 'scanning-media',
            slot: projectsProjectDetailHostSlots.tabs,
            contractVersion: projectsProjectDetailHostCapability,
            requiredPermission: 'scanning-media.scans.read',
            settingCondition: {
                key: 'scanning-media.scans.configuration',
                property: 'projectPanelEnabled',
                equals: true,
            },
            priority: 35,
            errorBehavior: 'inline',
            emptyBehavior: 'inline',
            launcher: defineProjectsProjectDetailLauncher({
                fallbackLabel: 'Scans and media',
                fallbackDescription: 'Open captures, scan review, and Project media evidence.',
                defaultSize: 'large',
                supportedSizes: ['standard', 'wide', 'large'],
            }),
            load: () => import('./scanning-media-project-scan-readback.panel.js'),
        }, {
            id: 'scanning-media.web.projects.assembly-review',
            moduleId: 'scanning-media',
            slot: projectsProjectDetailHostSlots.tabs,
            contractVersion: projectsProjectDetailHostCapability,
            requiredPermission: 'scanning-media.assembly.read',
            settingCondition: {
                key: 'scanning-media.assembly.configuration',
                property: 'projectAssemblyPanelEnabled',
                equals: true,
            },
            priority: 36,
            errorBehavior: 'inline',
            emptyBehavior: 'inline',
            load: () => import('./scanning-media-project-assembly-review.panel.js'),
        }, {
            id: 'scanning-media.web.projects.scan-assets',
            moduleId: 'scanning-media',
            slot: projectsProjectDetailHostSlots.tabs,
            contractVersion: projectsProjectDetailHostCapability,
            requiredPermission: 'scanning-media.assets.read',
            settingCondition: {
                key: 'scanning-media.assets.configuration',
                property: 'projectAssetPanelEnabled',
                equals: true,
            },
            priority: 37,
            errorBehavior: 'inline',
            emptyBehavior: 'inline',
            load: () => import('./scanning-media-project-scan-assets.panel.js'),
        }, {
            id: 'scanning-media.web.projects.coordinate-continuity',
            moduleId: 'scanning-media',
            slot: projectsProjectDetailHostSlots.tabs,
            contractVersion: projectsProjectDetailHostCapability,
            requiredPermission: 'scanning-media.coordinate-continuity.read',
            settingCondition: {
                key: 'scanning-media.coordinate-continuity.configuration',
                property: 'projectCoordinatePanelEnabled',
                equals: true,
            },
            priority: 38,
            errorBehavior: 'inline',
            emptyBehavior: 'inline',
            load: () => import('./scanning-media-project-coordinate-continuity.panel.js'),
        }],
    routes: [],
};
export default scanningMediaWebModuleContribution;
//# sourceMappingURL=scanning-media-web.module-contribution.js.map